module.exports = "/images/vendor/flag-icon-css/flags/4x3/eu.svg?ee7f4712ac4553621d85503cb9a130e5";